module.exports = __webpack_public_path__ + "static/media/01B.11642487.png";